import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Actions, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import {
  ADD_IMAGE_FAILURE,
  ADD_IMAGE_SUCCESS,
  AddImageAction,
} from "../images.actions";
import { ShowOnSubmitAttemptErrorStateMatcher } from "../../shared/error-state-matcher";

@Component({
  selector: "app-image-add",
  templateUrl: "./image-add.component.html",
  styleUrls: ["./image-add.component.scss"],
  standalone: false,
})
export class ImageAddComponent implements OnInit, OnDestroy {
  file: File | null = null;
  form: UntypedFormGroup;
  saving = false;
  errorStateMatcher = new ShowOnSubmitAttemptErrorStateMatcher();
  private readonly destroy$ = new Subject<void>();

  constructor(
    private store: Store,
    private dialogRef: MatDialogRef<ImageAddComponent>,
    private actions$: Actions,
  ) {}

  ngOnInit(): void {
    this.fillInitialForm();
    this.actions$
      .pipe(ofType(ADD_IMAGE_SUCCESS), takeUntil(this.destroy$))
      .subscribe(() => {
        this.saving = false;
        this.dialogRef.close(true);
      });
    this.actions$
      .pipe(ofType(ADD_IMAGE_FAILURE), takeUntil(this.destroy$))
      .subscribe(() => {
        this.saving = false;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  fillInitialForm = () => {
    this.form = new UntypedFormGroup({
      file: new UntypedFormControl("", (control) =>
        Validators.required(control),
      ),
      name: new UntypedFormControl("", (control) =>
        Validators.required(control),
      ),
    });
  };

  onSubmit = () => {
    this.errorStateMatcher.submitAttempted = true;
    if (this.saving || this.form.invalid || !this.file) {
      return;
    }
    this.saving = true;
    const name = String(this.form.get("name")?.value ?? "").trim();
    this.store.dispatch(
      new AddImageAction({
        file: this.file,
        name,
      }),
    );
  };

  fileChange = ({ file }: { file: File }) => {
    this.file = file;
    this.form.patchValue({ file: file.name });
    if (!this.form.get("name")?.value) {
      this.form.patchValue({ name: file.name.replace(/\.[^.]+$/, "") });
    }
  };

  removeFile = () => {
    this.file = null;
    this.form.patchValue({ file: "" });
  };

  cancel = () => {
    if (this.saving) {
      return;
    }
    this.fillInitialForm();
    this.dialogRef.close();
  };
}
